function CustomizeResultView() {
  return (
    <div>Done!</div>
  );
}

export default CustomizeResultView;
